import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LoggerService } from '../../../../services/logger.service';

interface DiscountPopupData {
  code: string;
  discountText: string;
}

@Component({
  selector: 'app-discount-popup',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './discount-popup.component.html',
  styleUrls: ['./discount-popup.component.scss']
})
export class DiscountPopupComponent {
  
  constructor(
    private logger: LoggerService,
    public dialogRef: MatDialogRef<DiscountPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DiscountPopupData
  ) {}

  copyCode(): void {
    if (this.data.code) {
      // Try modern clipboard API first
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.data.code).then(() => {
          this.logger.log('✅ Code copied to clipboard (modern API):', this.data.code);
        }).catch(err => {
          this.logger.error('Modern clipboard API failed, trying fallback:', err);
          this.fallbackCopyTextToClipboard(this.data.code);
        });
      } else {
        // Fallback for older browsers or non-secure contexts
        this.fallbackCopyTextToClipboard(this.data.code);
      }
    }
  }

  private fallbackCopyTextToClipboard(text: string): void {
    // Create a temporary textarea element
    const textArea = document.createElement('textarea');
    textArea.value = text;
    
    // Make it invisible but still focusable
    textArea.style.position = 'fixed';
    textArea.style.top = '-1000px';
    textArea.style.left = '-1000px';
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = '0';
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    
    // Add to DOM, select, copy, and remove
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this.logger.log('✅ Code copied to clipboard (fallback):', text);
      } else {
        this.logger.error('❌ Fallback copy failed');
        this.handleCopyFailure(text);
      }
    } catch (err) {
      this.logger.error('❌ Fallback copy error:', err);
      this.handleCopyFailure(text);
    } finally {
      document.body.removeChild(textArea);
    }
  }

  private handleCopyFailure(code: string): void {
    // Show user-friendly message or alternative action
    if (confirm(`Code konnte nicht automatisch kopiert werden.\n\nCode: ${code}\n\nManuell kopieren?`)) {
      // User can manually copy from the alert/prompt
      const selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
      }
    }
  }
}
